"use strict";

var _qrSvg = require("./components/qr-svg");

module.exports = { QRCode: _qrSvg.QRCode };


//////////////////
// WEBPACK FOOTER
// ./~/react-qr-svg/dist-modules/index.js
// module id = 1844
// module chunks = 1